import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setOptionEdit } from "../../reducer/tourEditReducer";
import { Paths } from "../../router/Paths";

export default function ManageProductPricingSection({ optionData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setOptionEdit(optionData._id));
    navigate(Paths.tourManagementPackageOptionsAvailabilityPrice, {
      state: { optionData },
    });
  };

  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Pricing</p>
        <button
          onClick={handleEdit}
          className="text-sm text-primary underline font-bold"
        >
          Edit
        </button>
      </div>
      {/* content  */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Pricing Option</p>
              <p className="text-secondary capitalize">
                {optionData?.pricingOption}
              </p>
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Pricing Per Individual</p>
              <p className="text-secondary capitalize">
                Value: ₦{optionData?.pricePerIndividual[0].value}
              </p>
              <p className="text-secondary capitalize">
                Calculated Price: ₦{optionData?.pricePerIndividual[0].value}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="text-sm font-bold">Pricing Per Age Group</p>
              <p className="text-secondary capitalize">
                Value: ₦
                {Array.isArray(optionData?.pricePerAgeGroup)
                  ? optionData.pricePerAgeGroup[0]?.value ?? 0
                  : 0}
              </p>
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Infant</p>
              <p className="text-secondary capitalize">
                Price: ₦{optionData?.infantPrice}
              </p>
              <p className="text-secondary capitalize">
                Selling Price: ₦{optionData?.sellingInfantPrice}
              </p>
              <p className="text-secondary capitalize">
                Calculated Price: ₦{optionData?.calculatedInfantPrice}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Adult</p>
              <p className="text-secondary capitalize">
                Price: ₦{optionData?.adultPrice}
              </p>
              <p className="text-secondary capitalize">
                Selling Price: ₦{optionData?.sellingAdultPrice}
              </p>
              <p className="text-secondary capitalize">
                Calculated Price: ₦{optionData?.calculatedAdultPrice}
              </p>
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Senior</p>
              <p className="text-secondary capitalize">
                Price: ₦{optionData?.seniorPrice}
              </p>
              <p className="text-secondary capitalize">
                Selling Price: ₦{optionData?.sellingSeniorPrice}
              </p>
              <p className="text-secondary capitalize">
                Calculated Price: ₦{optionData?.calculatedSeniorPrice}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Student</p>
              <p className="text-secondary capitalize">
                Price: ₦{optionData?.studentPrice}
              </p>
              <p className="text-secondary capitalize">
                Selling Price: ₦{optionData?.sellingStudentPrice}
              </p>
              <p className="text-secondary capitalize">
                Calculated Price: ₦{optionData?.calculatedStudentPrice}
              </p>
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Military</p>
              <p className="text-secondary capitalize">
                Price: ₦{optionData?.militaryPrice}
              </p>
              <p className="text-secondary capitalize">
                Selling Price: ₦{optionData?.sellingMilitaryPrice}
              </p>
              <p className="text-secondary capitalize">
                Calculated Price: ₦{optionData?.calculatedMilitaryPrice}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">eu Citizens</p>
              <p className="text-secondary capitalize">
                Price: ₦{optionData?.euCitizensPrice}
              </p>
              <p className="text-secondary capitalize">
                Selling Price: ₦{optionData?.sellingEuCitizensPrice}
              </p>
              <p className="text-secondary capitalize">
                Calculated Price: ₦{optionData?.calculatedEuCitizensPrice}
              </p>
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Group</p>
              <p className="text-secondary capitalize">
                Price: ₦{optionData?.groupPrice}
              </p>
              <p className="text-secondary capitalize">
                Selling Price: ₦{optionData?.sellingGroupPrice}
              </p>
              <p className="text-secondary capitalize">
                Calculated Price: ₦{optionData?.calculatedGroupPrice}
              </p>
            </div>
          </div>
        </div>

        {/* Price Per Vehicle Section */}
        {Array.isArray(optionData?.pricePerVehicle) &&
          optionData.pricePerVehicle.length > 0 && (
            <div className="w-full max-w-[836px] flex flex-col gap-6">
              <div className="w-full text-sm">
                <div className="space-y-2">
                  <p className="font-bold">Pricing Per Vehicle</p>
                  {optionData.pricePerVehicle.map(
                    (vehicle: any, idx: number) => (
                      <div key={idx} className="border-b border-gray-200 py-2">
                        <p className="text-secondary capitalize">
                          <span className="font-semibold">Group:</span>{" "}
                          {vehicle.name}
                        </p>
                        <p className="text-secondary capitalize">
                          <span className="font-semibold">Range:</span>{" "}
                          {vehicle.from} - {vehicle.to}
                        </p>
                        <p className="text-secondary capitalize">
                          <span className="font-semibold">Price:</span> ₦
                          {vehicle.price}
                        </p>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
      </div>
    </section>
  );
}
